import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { MaterialModule } from "../../../components/material/material.module";
import { CrearEntidadResponsableComponent } from "./crear-entidad-responsable/crear-entidad-responsable.component";
import { CrearEntidadResponsableDialog } from "./crear-entidad-responsable/crear-entidad-responsable-dialog/crear-entidad-responsable-dialog.component";
import { EliminarEntidadResponsableComponent } from "./eliminar-entidad-responsable/eliminar-entidad-responsable.component";
import { EliminarEntidadResponsableDialog } from "./eliminar-entidad-responsable/eliminar-entidad-responsable-dialog/eliminar-entidad-responsable-dialog.component";
import { EntidadResponsableComponent } from "./entidad-responsable/entidad-responsable.component";
import { EntidadResponsableService } from "./entidad-responsable/entidad-responsable.service";
import { ListarEntidadResponsablesComponent } from "./listar-entidad-responsables/listar-entidad-responsables.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
    ],
    declarations: [
        CrearEntidadResponsableComponent,
        CrearEntidadResponsableDialog,
        EliminarEntidadResponsableComponent,
        EliminarEntidadResponsableDialog,
        EntidadResponsableComponent,
        ListarEntidadResponsablesComponent,
    ],
    providers: [
        EntidadResponsableService
    ],
    entryComponents: [
        CrearEntidadResponsableDialog,
        EliminarEntidadResponsableDialog,
    ],
    exports: [
        CrearEntidadResponsableComponent,
        EliminarEntidadResponsableComponent,
        EntidadResponsableComponent,
        ListarEntidadResponsablesComponent,
    ]
})
export class EntidadResponsableModule { }